import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { QueryProvider, useDataModel } from '@thd-nucleus/data-sources';
import { dataModel, defaultGetQuoteListReq } from '../dataModels/dataModel';

export const QuotesContext = createContext();

const QuotesContextProvider = ({ children }) => {
  const { data, loading, error } = useDataModel('quoteList');

  const quoteList = data?.quoteList || [];

  return (
    <QuotesContext.Provider value={{ quoteList, loading, error }}>
      {children}
    </QuotesContext.Provider>
  );
};

QuotesContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const QuotesProvider = ({ children }) => {
  return (
    <QueryProvider
      cacheKey="quotes-list"
      defaultVariables={defaultGetQuoteListReq}
    >
      <QuotesContextProvider>
        {children}
      </QuotesContextProvider>
    </QueryProvider>
  );
};

QuotesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

QuotesProvider.dataModel = dataModel;